module.exports = __webpack_public_path__ + "img/login-account-admin.2279218d.png";